import { Component } from '@angular/core';

@Component({
  selector: 'app-assinatura-concluida',
  templateUrl: './assinatura-concluida.component.html',
  styleUrl: './assinatura-concluida.component.scss'
})
export class AssinaturaConcluidaComponent {

}
